// levenshtein-edit-distance was chosen because it is a more robust implementation of the Levenshtein distance algorithm
// It is fully typed, tested and is MIT licensed
import { levenshteinEditDistance } from 'levenshtein-edit-distance'
import { getBadActorFlagKey, setBadActorData } from './badActorStore'

/**
 * Checks if the edit distance between two strings exceeds a threshold.
 * If the distance is greater than the threshold, increments a counter in the bad actor data.
 *
 * @param {string} string1 - The first string to compare.
 * @param {string} string2 - The second string to compare.
 * @returns {Promise<boolean>} - A promise that resolves to true if the edit distance exceeds the threshold
 * and saving should be prevented, otherwise false.
 */
export default async function checkForBigEditDistance(string1, string2) {
  if (typeof string1 !== 'string' || typeof string2 !== 'string') {
    throw new Error('Both arguments must be strings')
  }
  const key = 'checkForBigEditDistance'
  const flagKey = await getBadActorFlagKey(key)
  const distance = levenshteinEditDistance(string1, string2)
  const badActorData = {}
  if (distance > flagKey.threshhold && flagKey.enabled) {
    badActorData.count = distance
    badActorData.pass = badActorData.count <= flagKey.threshhold
    badActorData.originalTerm = string2
    badActorData.editedTerm = string1
  }
  await setBadActorData(key, badActorData)
  return flagKey?.enabled ? distance > flagKey.threshhold : false
}
